import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Native-Angular port of the AngularJS `activityType` filter
 * (account-v1/src/sections/people/activityType.filter.js): maps a short
 * advocate-activity key to its translated label. Unknown keys render undefined
 * (-> empty), matching the original `typeMap[type]`.
 *
 * Resolves via the native ngx `TranslateService.instant` (the WS2 translate sweep
 * drained the AngularJS `$translate` `$injector` bridge).
 */
@Pipe({
    name: 'activityType',
    standalone: false
})
export class ActivityTypePipe implements PipeTransform {
  private static readonly TRANSLATION_KEYS: Record<string, string> = {
    'prestay.share': 'flipto.account.advocateActivity.prestay.share',
    quote: 'flipto.account.advocateActivity.quote',
    'photo.upload': 'flipto.account.advocateActivity.photo.upload',
    'photo.finalist': 'flipto.account.advocateActivity.photo.finalist',
    'photo.vote': 'flipto.account.advocateActivity.photo.vote',
    'photo.share': 'flipto.account.advocateActivity.photo.share',
  };

  private readonly translate = inject(TranslateService);

  transform(type: string | null | undefined): string {
    if (!type) return '';
    const key = ActivityTypePipe.TRANSLATION_KEYS[type];
    if (!key) return '';
    return this.translate.instant(key);
  }
}
